var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#747474;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    className: "st0",
    d: "M24,2.8V16c-0.1,1.6-1.4,2.9-3,2.8h-6.9c-0.2,0-0.4,0.1-0.6,0.2l-6.7,4.7 C5.8,24.3,4.6,24,4,23c-0.2-0.3-0.2-0.6-0.3-0.9v-2.5c0-0.4-0.4-0.7-0.8-0.7l0,0c-1.6,0-3-1.2-3-2.8V2.8C0,1.2,1.4,0,3,0h18 C22.6,0,24,1.2,24,2.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    transform: "translate(3.693 7.538)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_22",
    className: "st0",
    cx: 2,
    cy: 1.9,
    rx: 2,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_23",
    className: "st0",
    cx: 8.3,
    cy: 1.9,
    rx: 2,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_24",
    className: "st0",
    cx: 14.6,
    cy: 1.9,
    rx: 2,
    ry: 1.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e6e8390e2200a174474925d790336429.svg";
export { ForwardRef as ReactComponent };